module.exports = __webpack_public_path__ + "img/ygzs.e0868e8c.png";